// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner-image[data-v-4a406a50]{padding-bottom:60%}.banner-image.is-blog[data-v-4a406a50]{padding-bottom:40%}@media (min-width: 768px){.banner-image[data-v-4a406a50]{padding-bottom:22.5%}.banner-image.is-home[data-v-4a406a50]{padding-bottom:23.6%}.banner-image.is-blog[data-v-4a406a50]{padding-bottom:16%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
